module.exports = __webpack_public_path__ + "media/images/favicons/152px-51417d14678e16ad82faa089214ffee0.png";